import { render, staticRenderFns } from "./HelpArea.vue?vue&type=template&id=5d98a262&scoped=true&"
import script from "./HelpArea.vue?vue&type=script&lang=js&"
export * from "./HelpArea.vue?vue&type=script&lang=js&"
import style0 from "./HelpArea.vue?vue&type=style&index=0&id=5d98a262&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d98a262",
  null
  
)

export default component.exports